import React from 'react'
import Galeria from './Galeria'

const NuestrasMarcas = () => {
   return (
        <>
            <h3 className="text-center mt-3">Conoce nuestras marcas</h3>
           <Galeria
           tipo = "imagen"
           />
        </>
   )
}

export default NuestrasMarcas